import { useAuth } from '@api/accounts/auth/hooks/useAuth'
import { useLogin } from '@api/accounts/auth/hooks/useLogin'
import ButtonMinimal, {
  ButtonMinimalProps
} from '@components/ui/Button/ButtonMinimal'

export default function LoginLink({
  variant = 'primary' as keyof ButtonMinimalProps['variant']
}: { variant?: ButtonMinimalProps['variant'] } = {}) {
  const { logout } = useAuth()
  const { login, isLoggedIn } = useLogin()

  return (
    <>
      {isLoggedIn ? (
        <ButtonMinimal onClick={logout} variant={variant} underlined={true}>
          Log out
        </ButtonMinimal>
      ) : (
        <ButtonMinimal onClick={login} variant={variant} underlined={true}>
          Log in
        </ButtonMinimal>
      )}
    </>
  )
}
